import React from 'react'
import { SVGIconProps } from '../types'
const SvgChangeHistory = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M12 7.77 18.39 18H5.61zM12 4 2 20h20z" />
  </svg>
)
export default SvgChangeHistory
